export default "__VITE_ASSET__Dg0BgpSs__"